import React, { useState } from 'react'
import styled from 'styled-components'
import NavMarker from '../../organisms/StickyBar/NavMarkers.jsx'
import Header from '../../atoms/Header/Header'
import Text from '../../atoms/Text/Text'
import Overview from './Overview'
import Experience from './Experience'
import Treatment from './Treatment'
import media from 'styled-media-query'
import Divider from '@/components/Divider'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { isNonEmptyArray } from '../../../utils/checks'

const ModalStyle = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 1002;
  ${media.lessThan('medium')`
	left:0;
`}
  i {
    background: #ffffff;
    box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    font-size: 21px;
    padding: 11px 15px;
    color: #6b6b6b;

    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.05);
    }
  }
  .container {
    overflow: auto;
    background: white;
    margin: 0 auto;
    width: 100%;
    max-width: 623px;
    height: 100vh;
    z-index: 1002;
    padding: 20px 40px;
    box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.11);

    h4 {
      margin: 20px 0px;
    }
  }
`

const Overlay = styled.div`
  background: white;
  width: 100vw;
  height: 100%;
  opacity: 0.6;
  position: fixed;
  z-index: 1001;
  top: 0;
`

const displayItems = (title, array) => {
  const items = Array.from(new Set(array))

  return (
    <div>
      {typeof array != 'undefined' && array != null && array.length > 0 && (
        <React.Fragment>
          <Header
            style={{ marginBottom: '10px' }}
            display={4}
            align="left"
            as="h4"
          >
            {title}
          </Header>
          {items.sort().map((item) => {
            return (
              <Text
                small
                key={item}
              >
                {item}
              </Text>
            )
          })}
        </React.Fragment>
      )}
    </div>
  )
}
const Modal = ({ toggleModal, data }) => (
  <ModalStyle onClick={toggleModal}>
    <div className="container">
      <FontAwesomeIcon icon={faXmark} />
      {displayItems('Therapies', data.therapies)}
      {displayItems('Treatment Philosphy', data.treatment_method)}
      {displayItems('Conditions Treated', data.what_we_treat)}
      {displayItems('Aftercare', [
        ...(data.arranged_aftercare || []),
        ...(data.included_aftercare || [])
      ])}
      {displayItems('Aftercare Not Included', data.aftercareNotIncluded)}
      {displayItems('Amenities', data.amenities)}
      {displayItems('Offsite Amenities', data.off_amenities)}
      {displayItems('Personal Amenities', data.personal_amenities)}
      {displayItems('On-Site Amenities', data.onsite_amenities)}
      {displayItems('On-site Activities', data.onsite_activities)}
      {displayItems('Off-Site Activities', data.off_site_activities)}
      {displayItems('Special Considerations', data.special_considerations)}
    </div>
    <div
      onClick={toggleModal}
      className="overlay"
    />
  </ModalStyle>
)

export default function TaxonomySection({ data, standard, taxonomyList }) {
  const [state, setState] = useState({
    modalOpen: false
  })
  const toggleModal = () => {
    if (!state.modalOpen) {
      document.querySelector('html').style.overflow = 'hidden'
    } else {
      document.querySelector('html').style.overflow = null
    }
    setState({
      ...state,
      modalOpen: !state.modalOpen
    })
  }

  const {
    _special_considerations: special_considerations,
    _amenities: amenities,
    activities,
    _off_site_activities: off_site_activities,
    _onsite_activities: onsite_activities,
    onsite_amenities,
    off_site_amenities,
    personal_amenities
  } = data

  const shouldRenderExperience =
    isNonEmptyArray(special_considerations) ||
    isNonEmptyArray(amenities) ||
    isNonEmptyArray(activities) ||
    isNonEmptyArray(off_site_activities) ||
    isNonEmptyArray(onsite_activities) ||
    isNonEmptyArray(onsite_amenities) ||
    isNonEmptyArray(off_site_amenities) ||
    isNonEmptyArray(personal_amenities)

  return (
    <>
      {state.modalOpen && (
        <React.Fragment>
          <Modal
            data={data}
            toggleModal={toggleModal}
          />
          <Overlay />
        </React.Fragment>
      )}

      <NavMarker id="profile-treatments">
        <Overview
          data={{
            address: data.overviewAddress,
            founded: data.founded,
            specializations: data.specializations,
            therapies: data.therapies,
            occupancy: data.occupancy,
            languages: data.languages,
            accredidation: data.accredidation,
            price_length: data.price_length,
            acceptsInsurance: data.acceptsInsurance,
            treatment_services: data.treatment_services,
            who_we_treat: data.who_we_treat,
            primaryFocus: data.primaryFocus,
            _what_we_treat: data._what_we_treat,
            what_we_treat: data.what_we_treat,
            price_label: data.price_label,
            length_label: data.length_label,
            isStandard: data.is_standard
          }}
          toggleModal={toggleModal}
        />
      </NavMarker>

      <Divider />

      <NavMarker
        standard
        id="care-options"
      >
        <Treatment
          data={{
            _treatment_method: data._treatment_method,
            arranged_aftercare: data.arranged_aftercare,
            new_specializations: data._new_specializations,
            treatment_method: data.treatment_method,
            included_aftercare: data.included_aftercare,
            specializations: data.new_specializations,
            therapies: data._therapies,
            aftercare: data.aftercare,
            what_we_treat: data._what_we_treat,
            locations: data.locations,
            _treatment_services: data._treatment_services,
            is_standard: data.is_standard,
            taxonomyList: taxonomyList,
            primaryFocus: data.primaryFocus
          }}
          toggleModal={toggleModal}
        />
      </NavMarker>

      <Divider />

      <NavMarker
        standard={standard}
        id="profile-amenities"
      >
        {shouldRenderExperience && (
          <Experience
            data={{
              special_considerations,
              amenities,
              activities,
              off_site_activities,
              onsite_activities,
              onsite_amenities,
              off_site_amenities,
              personal_amenities
            }}
            toggleModal={toggleModal}
          />
        )}
      </NavMarker>
    </>
  )
}
